module.exports = __webpack_public_path__ + "img/logo.7e819918.png";